import BlockIcon from '@mui/icons-material/Block'
import BuildOutlinedIcon from '@mui/icons-material/BuildOutlined'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import PriorityHighOutlinedIcon from '@mui/icons-material/PriorityHighOutlined'
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined'

import EnumIconSelectInput, { EnumField } from '../../components/EnumIconSelectInput'
import {
  INCIDENT_REPORT_SEVERITY_CRITICAL,
  INCIDENT_REPORT_SEVERITY_HIGH,
  INCIDENT_REPORT_SEVERITY_LOW,
  INCIDENT_REPORT_SEVERITY_MEDIUM,
} from '../../config/damages'

export const SEVERITY_VISUALS = {
  LOW: { color: '#22c55e', backgroundColor: '#ecfdf5', icon: InfoOutlinedIcon },
  MEDIUM: { color: '#ca8a04', backgroundColor: '#fefce8', icon: BuildOutlinedIcon },
  HIGH: { color: '#ea580c', backgroundColor: '#fff7ed', icon: WarningAmberOutlinedIcon },
  CRITICAL: { color: '#dc2626', backgroundColor: '#fef2f2', icon: BlockIcon },
}

export const damageSeverityChoices = [
  {
    id: INCIDENT_REPORT_SEVERITY_LOW,
    icon: InfoOutlinedIcon,
    iconColor: SEVERITY_VISUALS.LOW.color,
  },
  {
    id: INCIDENT_REPORT_SEVERITY_MEDIUM,
    icon: BuildOutlinedIcon,
    iconColor: SEVERITY_VISUALS.MEDIUM.color,
  },
  {
    id: INCIDENT_REPORT_SEVERITY_HIGH,
    icon: WarningAmberOutlinedIcon,
    iconColor: SEVERITY_VISUALS.HIGH.color,
  },
  {
    id: INCIDENT_REPORT_SEVERITY_CRITICAL,
    icon: BlockIcon,
    iconColor: SEVERITY_VISUALS.CRITICAL.color,
  },
]

export const IncidentSeverityField = (props) => (
  <EnumField resource="incident-reports" source="severity" choices={damageSeverityChoices} {...props} />
)

export const getIncidentReportSeverityIcon = (severityId) =>
  SEVERITY_VISUALS[severityId]?.icon || PriorityHighOutlinedIcon

const SeveritySelectInput = ({ excludeValues = [], ...props }) => {
  const filteredChoices = excludeValues.length
    ? damageSeverityChoices.filter((choice) => !excludeValues.includes(choice.id))
    : damageSeverityChoices

  return <EnumIconSelectInput source="severity" choices={filteredChoices} {...props} />
}

export default SeveritySelectInput
